import createEnum from 'lib/createEnum';

export const MESSAGE_CREATE_UPDATE_START = 'messages/CREATE_START';
export const MESSAGE_CREATE_UPDATE_SENDING = 'messages/CREATE_SENDING';
export const MESSAGE_CREATE_UPDATE_SUCCESS = 'messages/CREATE_UPDATE_SUCCESS';
export const MESSAGE_CREATE_UPDATE_FAILURE = 'messages/CREATE_UPDATE_FAILURE';
export const MESSAGE_CREATE_PENDING = 'messages/CREATE_PENDING';

export const CLEAR_MESSAGES = 'messages/CLEAR_MESSAGES';
export const CLEAR_PENDING_MESSAGES = 'messages/CLEAR_PENDING_MESSAGES';

// metadata subTypes
export const SUB_TYPES = createEnum('TEXT', 'SESSION_END', 'URL');
